import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parseCookies } from 'nookies';
import { Layout, Header, Footer, ReviewsPageLayout } from "../components";
import { axiosInstance } from "../utils";

class ReviewsPage extends Component {
  static propTypes = {
    reviews: PropTypes.instanceOf(Object),
    hotels: PropTypes.instanceOf(Object),
    hotelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    counter: PropTypes.number,
  };

  static async getInitialProps(ctx) {
    const { query, req } = ctx;
    const { hotelId } = query;
    let cookie;

    if (req) {
      cookie = `sid=${parseCookies(ctx).sid};`;
    }

    const { data } = await axiosInstance.get(`hotels/reviews${typeof hotelId !== 'undefined' ? `?hotelId=${hotelId}` : ''}`, req && {
      headers: {
        Cookie: cookie,
      }
    });

    return { ...data, hotelId: typeof hotelId !== 'undefined' ? Number(hotelId) : undefined };
  }

  constructor(props) {
    super(props);
    const { reviews, hotels, hotelId, counter } = props;
    const { total, reviewsList } = reviews;
    const selectedHotel = hotels.find(hotel => hotel.hotelId === hotelId);
    const filteredHotelList = hotels.filter(hotel => hotel.hotelId !== hotelId);

    this.state = {
      counter,
      hasMore: reviewsList.length < total,
      reviewsList,
      hotels: filteredHotelList,
      total,
      selectedHotel: hotelId && {
        ...selectedHotel,
        totalReviews: total,
      },
      page: 0,
    };
  }

  componentDidUpdate(prevProps) {
    const { hotelId: prevHotelId } = prevProps;
    const { hotelId: newHotelId, reviews, hotels, counter } = this.props;
    const { total, reviewsList } = reviews;

    if (prevHotelId !== newHotelId) {
      const selectedHotel = hotels.find(hotel => hotel.hotelId === newHotelId);
      const filteredHotelList = hotels.filter(hotel => hotel.hotelId !== newHotelId);
      this.setState({
        counter,
        hasMore: reviewsList.length < total,
        reviewsList,
        hotels: filteredHotelList,
        total,
        selectedHotel: {
          ...selectedHotel,
          totalReviews: total,
        },
        page: 0,
      })
    }
  }

  fetchMoreSearchResults = async () => {
    this.setState(prevState => ({
      page: prevState.page + 1,
    }));

    const { page } = this.state;
    const { hotelId } = this.props;

    const { data: reviewsData } = await axiosInstance.get(`hotels/reviews${typeof hotelId !== 'undefined' ? `?hotelId=${hotelId}&` : '?'}limit=10&offset=${page * 10}`);
    const { reviews } = reviewsData;
    const { total, reviewsList } = reviews;

    this.setState(prevState => ({
      hasMore: [...prevState.reviewsList, ...reviewsList].length < total,
      reviewsList: [...prevState.reviewsList, ...reviewsList],
      total,
    }));
  };

  render() {
    const { fetchMoreSearchResults } = this;
    const { counter, hasMore, reviewsList, total, selectedHotel, hotels } = this.state;

    return (
      <Layout heading="Hotel Reviews | Dayaxe.com">
        <Header isInnerPage fixed />
        <ReviewsPageLayout
          reviewsList={reviewsList}
          hotels={hotels}
          hasMore={hasMore}
          total={total}
          handlePageScrollLoading={fetchMoreSearchResults}
          selectedHotel={selectedHotel}
          counter={counter}
        />
        <Footer isInnerPage />
      </Layout>
    );
  }
}

export default ReviewsPage;
